export const CreatorInviteeStatusCssClasses = ["danger", "success", "info", ""];
export const CreatorInviteeStatusTitles = ["Rejected", "INVITED", "Pending", ""];
export const CreatorInviteeTypeCssClasses = ["success", "primary", ""];
export const CreatorInviteeTypeTitles = ["Business", "Individual", ""];
export const defaultSorted = [{ dataField: "createdAt", order: "desc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  query:{},
  sort:"-updatedAt",
  sortOrder: "asc", // asc||desc
  sortField: "id",
  page: 1,
  pageSize: 10
};